import { MarketModel, IMarketModel } from '@common/models/MarketModel';
import { http } from '@common/utils';
import { trackPromise } from 'react-promise-tracker';
import { ServiceHelper } from '../serviceHelper';
import { ServiceMethodOptions } from '../types';

export class MarketService {
  private static baseUrl: string = '/api/market';

  static tags = {
    market: 'market',
    getMarkets: 'getMarkets',
  };

  static getMarketById = (
    marketId: number,
    options?: ServiceMethodOptions,
  ): Promise<MarketModel> => {
    return trackPromise(
      new Promise<MarketModel>((resolve, reject) => {
        http(`${this.baseUrl}/${marketId}`)
          .get<IMarketModel[]>()
          .then((response) => {
            ServiceHelper.showSuccess('Market fetched', options);
            resolve(new MarketModel(response[0]));
          })
          .catch((err) => {
            ServiceHelper.showError('Failed to get Market.', options);
            reject(err);
          });
      }),
    );
  };

  static getMarkets = (): Promise<IMarketModel[]> => {
    return trackPromise(
      new Promise<IMarketModel[]>((resolve, reject) => {
        http(`${this.baseUrl}`)
          .get<IMarketModel[]>()
          .then((response) => response.map((mm) => new MarketModel(mm)))
          .then(resolve)
          .catch((err) => {
            reject(err);
          });
      }),
      this.tags.getMarkets,
    );
  };

  static upsertMarket = (
    data: IMarketModel,
    options?: ServiceMethodOptions,
  ): Promise<MarketModel> => {
    return trackPromise(
      new Promise<IMarketModel>((resolve, reject) => {
        http(`${this.baseUrl}`)
          .post<IMarketModel>(data)
          .then((response) => {
            ServiceHelper.showSuccess('Market updated.', options);
            resolve(new MarketModel(response));
          })
          .catch((err) => {
            ServiceHelper.showError('Failed to update Market.', options);
            reject(err);
          });
      }),
      this.tags.market,
    );
  };

  static deleteMarket = (
    marketId: number,
    options?: ServiceMethodOptions,
  ): Promise<boolean> => {
    return trackPromise(
      new Promise<boolean>((resolve, reject) => {
        http(`${this.baseUrl}/${marketId}`)
          .delete()
          .then(() => {
            ServiceHelper.showSuccess('Market has been deleted.', options);
            resolve(true);
          })
          .catch((err) => {
            ServiceHelper.showError('Failed to delete Market.', options);
            reject(err);
          });
      }),
      this.tags.market,
    );
  };
}
